import { render, staticRenderFns } from "./HistoryArchiveSimple.vue?vue&type=template&id=774dc77e"
import script from "./HistoryArchiveSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryArchiveSimple.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports